<template>
    <div class="event">
      <div class="pay">
        <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
        <form class="app-pay-form" @submit.prevent="send">
          <slot v-if="form.provider != 'bank'">
            <div class="col">
              <div class="inline-form">
                <label>Kart üzerindeki Ad Soyad</label>
                <input type="text" v-model="form.card_printed_name" placeholder="John Value" autocomplete="off">
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>Kart Numaranız</label>
                <input :type="isMobile ? 'tel' : 'number'" v-model="form.cardnum" oninput="if(value.length>16)value=value.slice(0,16)"  placeholder="Kart numaranızı yazınız" autocomplete="off">
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>S.K.T Ay</label>
                <select v-model="form.expire_month">
                    <option value="">Seçiniz</option>
                    <option  v-for="key in (_.range(1, 13) . map(num => ('0' + num).slice(-2)))" :key="key" :value="key">{{ key }}</option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>S.K.T Yıl</label>
                <select v-model="form.expire_year" oninput="if(value.length>4)value=value.slice(0,4)">
                    <option value="">Seçiniz</option>
                    <option  v-for="key in (_.range(current_year, (current_year + 20)))" :key="key" :value="key">{{ key }}</option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>CVV</label>
                <input :type="isMobile ? 'tel' : 'number'" v-model="form.cvv" oninput="if(value.length>3)value=value.slice(0,3)" id="card-cvv" placeholder="000" autocomplete="off">
              </div>
            </div>
          </slot>
            <div class="col">
                <div class="inline-form">
                    <label>Tutar</label>
                    <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
                </div>
            </div>
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Ödemeyi Başlat'" />
        </form>
      </div>
    </div>
  </template>
  
  <script>
    import Header from '../../../../components/User/Pay/Header'
    import Form from '../../../../components/User/Pay/Form'
  
    export default{
      props:['providerInfo'],
      data(){
        return{
          btnLoading: false,
          form: {
              cardnum: null,
              cvv: null,
              expire_date: null,
              amount: null,
              card_printed_name:null,
              card_type:'visa',
              expire_year: '',
              expire_month: '',
              provider    : 'bank',
          },
          loading: false
        }
      },
      created(){
        this.form.provider = this.provider;
      },
      computed: {
          current_year: function () {
              return parseInt(this.$moment().format('YYYY'));
          },
          provider() {
              return _.includes(this.$route.params.payment, 'sistemnakit_') ? _.replace(this.$route.params.payment, 'sistemnakit_', '') : this.$route.params.payment;
          }
      },
      methods:{
        send() {
          this.btnLoading = true;
          axios.post('/user/wallet/deposit/sistemnakit/create', this.form)
          .then((response) => {
            if (response.data.status) {
                location.href = response.data.url;
            }
          })
          .catch((err) => {
          })
          .finally(() => {
            this.btnLoading = false;
          });
        },
      },
      components:{
        Header,
        Form
      }
    }
  
  </script>